import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungBottrop() {
  return (
    <CityPageTemplate
      city="Bottrop"
      slug="bottrop"
      intro="Bottrop im Ruhrgebiet im Wandel – nutze staatliche Förderungen und smarte Geldanlage für Deine Zukunft."
      description="Unabhängige & digitale Finanzberatung für Bottrop: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
